import { render, staticRenderFns } from "./DragDropUploader.vue?vue&type=template&id=2ffee8eb&scoped=true&"
import script from "./DragDropUploader.vue?vue&type=script&lang=js&"
export * from "./DragDropUploader.vue?vue&type=script&lang=js&"
import style0 from "./DragDropUploader.vue?vue&type=style&index=0&id=2ffee8eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffee8eb",
  null
  
)

export default component.exports